import { atom } from "jotai";


export const isGenerateObjectiveModalOpenAtom = atom(false);